import React, { useEffect } from 'react';
import AkSpinner from '@atlaskit/spinner';
import { SpinnerContainer } from '../../styled/Card';
import { profileCardRendered } from '../../util/analytics';
export var LoadingState = function LoadingState(_ref) {
  var fireAnalytics = _ref.fireAnalytics,
    profileType = _ref.profileType;
  useEffect(function () {
    if (fireAnalytics) {
      fireAnalytics(profileCardRendered(profileType, 'spinner'));
    }
  }, [fireAnalytics, profileType]);
  return /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(AkSpinner, null));
};